import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { platformApi } from '@/features/platform/api';

/** UI gating only — organization-service enforces superadmin on every create. */
export function usePlatformCapabilities() {
  const { status, user } = useAuth();
  const q = useQuery({
    queryKey: ['platform', 'capabilities', user?.id],
    queryFn: platformApi.capabilities,
    enabled: status === 'authenticated',
    staleTime: 300_000,
    retry: false,
  });
  return {
    ...q,
    canOnboard: q.data?.canOnboardOrganizations === true,
    canAccessMailboxInbox: q.data?.canAccessMailboxInbox === true,
  };
}

export function useCreateOwnerWebmailSession() {
  return useMutation({ mutationFn: platformApi.createOwnerWebmailSession });
}

export function useOnboardOrganization() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: platformApi.onboardOrganization,
    // The caller becomes Owner of the new organization: refresh the selector + KPIs.
    onSuccess: () => Promise.all([
      qc.invalidateQueries({ queryKey: ['auth', 'tenants'] }),
      qc.invalidateQueries({ queryKey: ['dashboard', 'orgs'] }),
    ]),
  });
}
